var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { memoize } from '../../../../utils/mobx/decorators/memoize';
import { primitive } from '../../../../utils/serializr/schema/inner/primitive';
import { withDefault } from '../../../../utils/serializr/schema/middle/withDefault';
import { custom } from '../../../../utils/serializr/serializr';
export class AnswerStore {
    parent;
    constructor({ parent }) {
        this.parent = parent;
    }
    get answer() {
        return this.parent;
    }
    get a() {
        if (!this.answer.question)
            return undefined;
        return this.answer.question.questionScore.answerData;
    }
    set a(a) {
        if (!this.answer.question)
            return;
        this.answer.question.questionScore.answerData = a;
    }
    static get serializeInfo() {
        return {
            props: {
                s: withDefault(primitive, () => Date.now()),
                a: custom(a => a, a => a),
            },
        };
    }
}
__decorate([
    memoize
], AnswerStore, "serializeInfo", null);
